// @flow
import React from 'react';

import { updateOeuvreConsigne, createOeuvreConsigne } from 'Api';
import ConsigneOeuvreForm from 'pages/Avila/ConsigneOeuvre/Form'

import FormModal from './FormModal'
import { useTranslation } from 'react-i18next'

type Props = {
    consignationId: any,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any
}
export default ({
    onClose,
    actions = [],
    data,
    consignationId,
    onSave = () => {}
}: Props) => {
    
    const { t } = useTranslation();

    return (

        <FormModal
            title={t("oeuvre")}
            data={data}
            onClose={onClose}
            FormComponent={ConsigneOeuvreForm}

            onSave={onSave}
            updateMethod={({ data }) => updateOeuvreConsigne({ consignationId, data })}
            createMethod={({ data }) => createOeuvreConsigne({ consignationId, data })}
        />
    )
}